// extracted by mini-css-extract-plugin
export var card = "_4i-0";
export var content = "_4i-1";
export var contentLoading = "_4i-2";